import { useMutation } from '@tanstack/vue-query'
import { DateTime } from 'luxon'

import { explorerApi } from '~/api/client'
import { CommonFeedbackRequest } from '~/api/repository'
import { META } from '~/environment-variables/meta.const'
import { type IFeedbackForm } from '~/types/feedback.type'

export const feedbackService = {
  useCreateFeedback: () => {
    const createFeedback = (param: IFeedbackForm) => {
      return explorerApi.feedbackController.feedback({
        requestBody: {
          feedbackType: param.type || CommonFeedbackRequest.feedbackType.OTHER,
          comment: param.comment,
          url: param.url || undefined,
          timestamp: DateTime.now().toUTC().toSeconds(),
        }
      })
    }
    return useMutation(createFeedback)
  }
}